import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { Merchant } from 'models/app';
import { useAppContext } from '../../hooks/useAppContext';
import { useFetchMerchantQuery } from '../../redux/api/appMarket-api-slice';

export type MerchantContextType = {
  merchantData: Maybe<Merchant>;
  isLoading: boolean;
};

const defaultValues: MerchantContextType = {
  merchantData: undefined,
  isLoading: false,
};

export const MerchantContext = createContext<MerchantContextType>(defaultValues);
MerchantContext.displayName = 'MerchantContext';

export const useMerchant = () : MerchantContextType => useContext(MerchantContext);

export const MerchantContextProvider : React.FC<PropsWithChildren<{}>> = (props : PropsWithChildren<{}>) : JSX.Element => {
  const { children } = props;
  const merchantId = useAppContext()?.id || '';
  const {data: merchantData, isLoading} = useFetchMerchantQuery(merchantId, {
    skip: !merchantId
  });
  
  const value = useMemo(() => {
    return {
      isLoading,
      merchantData,
    };
  }, [merchantData, isLoading]);

  return (
    <MerchantContext.Provider value={value}>
      {children}
    </MerchantContext.Provider>
  );
};
